var map = {
	"./illus1.png": "N3cG",
	"./illus2.png": "FmPB",
	"./illus3.png": "FtLm",
	"./illus4.png": "1Pzv",
	"./illustration.png": "1j+n"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zj7c";


//////////////////
// WEBPACK FOOTER
// /src/assets/img ^\.\/illus.*\.png$
// module id = zj7c
// module chunks = 1